interface ServiceMainTitle {
  category: string
  title: string
  sub_title: string
  sub_title2: string
  text: string
  imgSrc: string;
}

export const serviceMainTitle: ServiceMainTitle = {
  category: 'デジタルイノベーションサポート',
  title: 'DX戦略策定',
  sub_title: '',
  sub_title2: '',
  text:
    'クラウド基盤ならびに生成AIといった、テクノロジーを活用した業務効率化・生産性向上・コスト削減を実現するため、DX戦略の策定支援を行います。',
  imgSrc: '/images/img/service/img_service_site-growth.png',
}
